module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section03_02_american-village-65ca2e88069ca83004c55281b3487824.jpg";